import script from "./SVGIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SVGIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SVGIcon.vue?vue&type=style&index=0&id=1c9dc480&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9dc480"]])

export default __exports__